import axios from 'axios'

let _svc
let _that

export default {
  // List
  GetList: () => {
    try {
      return _svc.get('Test/List')
    } catch {
      return null
    }
  },

  // Detail
  GetDetail: (id) => {
    try {
      return _svc.get(`Test/Detail/${id}`)
    } catch {
      return null
    }
  },
  SaveDetail: (detail) => {
    try {
      return _svc.put('Test/Detail/Save', detail)
    } catch {
      return null
    }
  },

  // Other
  Init: (that) => {
    _that = that

    _svc = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  }
}
